import ResponsiveStepper from './ResponsivelStepper';

export default ResponsiveStepper;
